import { Vue } from 'vue-property-decorator';

export default class MasterSetting extends Vue {
}